import { createActions, createReducer } from 'reduxsauce'

import ConsultaConvenioParceriaRecebidoService from '../../servicos/ConsultaConvenioParceriaRecebidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaConvenioParceriaRecebidoInicio: [],
    buscaConsultaConvenioParceriaRecebidoSucesso: ['consultaConvenioParceriaRecebido'],
    buscaConsultaConvenioParceriaRecebidoErro: ['erro'],
    setSelecionadoConsultaConvenioParceriaRecebidoSucesso: ['selecionado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataSincronizacaoDados: null,
}

// Ação para busca completa
Creators.buscaConsultaConvenioParceriaRecebido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaConvenioParceriaRecebidoInicio())
        let serv = new ConsultaConvenioParceriaRecebidoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaConvenioParceriaRecebidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaConvenioParceriaRecebidoErro(error)))
    }
}

const buscaConsultaConvenioParceriaRecebidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaConvenioParceriaRecebidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaConvenioParceriaRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaConvenioParceriaRecebido.resultado,
        dataSincronizacaoDados: action.consultaConvenioParceriaRecebido.dataSincronizacaoDados,
        carregando: false,
    }
}

const setSelecionadoConsultaConvenioParceriaRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CONVENIO_PARCERIA_RECEBIDO_INICIO]: buscaConsultaConvenioParceriaRecebidoInicio,
    [Types.BUSCA_CONSULTA_CONVENIO_PARCERIA_RECEBIDO_ERRO]: buscaConsultaConvenioParceriaRecebidoErro,
    [Types.BUSCA_CONSULTA_CONVENIO_PARCERIA_RECEBIDO_SUCESSO]: buscaConsultaConvenioParceriaRecebidoSucesso,
    [Types.SET_SELECIONADO_CONSULTA_CONVENIO_PARCERIA_RECEBIDO_SUCESSO]: setSelecionadoConsultaConvenioParceriaRecebidoSucesso,
})
